import React from "react";
import "./TermsOfService.css";

const TermsOfUse: React.FC = () => {
  return (
    <div className="tosPage">
      <div className="tosContainer">
        <h1 className="tosTitle">Terms of Use for German A1-C2</h1>

        <p>
          These Terms of Use (“Terms”) govern your access to and use of the
          German A1-C2 app (“App”, “we”, “us”, or “our”). By downloading,
          accessing, or using the App, you agree to these Terms. If you do not
          agree, please do not use the App.
        </p>

        <h2>1. The Service</h2>
        <p>
          German A1-C2 provides German language learning content. The App may
          include free content, premium content, and advertisements for
          non-premium users.
        </p>

        <h2>2. Free and Premium Access</h2>
        <p>The App may offer both free access and premium access.</p>
        <p>
          <strong>Free users:</strong> may have limited access to certain
          content and may see advertisements.
        </p>
        <p>
          <strong>Premium users:</strong> may receive access to additional or
          full content, offline access, and an ad-reduced or ad-free experience,
          depending on the version of the App and the active subscription
          offering.
        </p>

        <h2>3. Subscriptions</h2>
        <p>
          Premium access may be offered as an auto-renewable subscription.
          Subscription title, duration, and pricing are shown in the App before
          purchase.
        </p>
        <p>
          Payment will be charged through the platform you use to subscribe,
          such as Apple App Store or Google Play. Subscriptions automatically
          renew unless cancelled at least 24 hours before the end of the current
          billing period, unless otherwise stated by the platform.
        </p>

        <h2>4. Billing and Renewal</h2>
        <p>
          The exact subscription price may vary by country, currency, taxes,
          promotional offer, storefront, or platform. The price displayed in the
          App at the time of purchase is the price that applies to your
          subscription.
        </p>

        <h2>5. Cancellation and Restoration</h2>
        <p>
          You can manage or cancel your subscription through your Apple App
          Store or Google Play account settings, depending on where you
          subscribed. If you cancel, your premium access will continue until the
          end of the current paid billing period. Eligible purchases may also be
          restored through the App where supported.
        </p>

        <h2>6. Offer Codes and Promotional Access</h2>
        <p>
          The App may support promotional or access codes. Such codes may grant
          limited or full premium access for a specified time period and may be
          subject to expiration, eligibility requirements, or other conditions.
          Promotional access does not guarantee permanent premium access unless
          explicitly stated.
        </p>

        <h2>7. Advertising</h2>
        <p>
          Free users may see advertisements in the App. Ads may be served by
          third-party providers. We are not responsible for third-party
          advertisements, websites, products, or services linked from or shown
          through those ads.
        </p>

        <h2>8. Acceptable Use</h2>
        <p>
          You agree not to misuse the App. This includes, without limitation:
        </p>
        <p>
          • attempting to bypass subscription restrictions or content access
          controls
          <br />
          • reverse engineering, copying, modifying, or redistributing the App
          except as allowed by law
          <br />• using the App in a way that violates any applicable law or
          regulation
        </p>

        <h2>9. Intellectual Property</h2>
        <p>
          All content, trademarks, branding, text, audio, visuals, lessons, and
          other materials made available in the App are owned by us or licensed
          to us and are protected by applicable intellectual property laws. You
          may not copy, reproduce, republish, or distribute App content without
          permission.
        </p>

        <h2>10. Disclaimer</h2>
        <p>
          The App is provided on an “as is” and “as available” basis. We do not
          guarantee that the App will always be uninterrupted, secure,
          error-free, or available at all times. Language learning outcomes vary
          by user.
        </p>

        <h2>11. Limitation of Liability</h2>
        <p>
          To the maximum extent permitted by applicable law, we are not liable
          for any indirect, incidental, consequential, special, or punitive
          damages arising out of or related to your use of the App.
        </p>

        <h2>12. Changes to These Terms</h2>
        <p>
          We may update these Terms from time to time. When we do, we will post
          the revised Terms on this page. Continued use of the App after the
          updated Terms become effective means you accept them.
        </p>

        <h2>13. Contact Us</h2>
        <p>
          If you have any questions about these Terms, please contact us at{" "}
          <a href="mailto:kugathaj@gmail.com">kugathaj@gmail.com</a>.
        </p>
      </div>
    </div>
  );
};

export default TermsOfUse;
